import { DadosUsuarioService } from 'src/app/services/dados-usuario.service';
import { BaseFormService } from './../../services/base-form.service';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs/operators';
import { AlertErroComponent } from '../alert-erro/alert-erro.component';
import { AlertSucessoComponent } from '../alert-sucesso/alert-sucesso.component';
import { FormsModule } from '@angular/forms';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'app-alert-novo-cargo',
    templateUrl: './alert-novo-cargo.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AlertErroComponent, AlertSucessoComponent, FormsModule, PopoverDirective, UpperCasePipe]
})
export class AlertNovoCargoComponent implements OnInit {

  @Input() alertIncluirCargo: boolean = false;
  @Output() alertIncluirCargoFechou = new EventEmitter( );

  public novoCargo : string;
  public listaCargos : Array<string> = [];
  public listaCargosEnviados: Array<string> = [];
  public idEmpresa: any;
  public resposta: any;
  public procuraCargo: any;

  public alertErro: boolean = false;
  public mensagemErro: any;

  public alertSucesso: any;
  public alertSucessoMensagem: any = "Sucesso ao criar novo cargo!";
  public alertSucessoSubtitulo: any = "";

  constructor(private readonly dadosUsuarioService: DadosUsuarioService,
              private readonly baseFormService: BaseFormService) { }

  ngOnInit(): void {
    this.idEmpresa = this.baseFormService.getIdEmpresaLocalStorage();
  }

  onSubmit(){
    this.enviarDados(this.listaCargosEnviados);
  }

  public cancelarIncluirCargo(){
    this.alertIncluirCargoFechou.emit("cancelar");
    this.novoCargo = null;
    this.listaCargos = [];
  }

  public fecharIncluirCargo(){
    this.alertIncluirCargo = false
    this.alertIncluirCargoFechou.emit(this.alertIncluirCargo);
    this.novoCargo = null;
    this.listaCargos = [];
  }

  public adicionarCargos(){
    if (this.novoCargo == null){
      this.mensagemErro = "Por favor, digite o nome do cargo.";
      this.abriAlertErro();
    }
    else{
    this.listaCargos.push(this.novoCargo.toUpperCase());
    this.listaCargosEnviados.push(this.novoCargo.toUpperCase());
    this.novoCargo = null;
    }
  }

  public eventoAlertErroFechou(event: any){
    this.alertErro = event;
  }

  public abriAlertErro(){
    this.alertErro = true;
  }

  public eventoAlertSucessoFechou(event: any) {
    this.alertSucesso = event;
  }

  public abrirAlertSucesso() {
    this.alertSucesso = true;
  }

  public enviarDados(lista){

    if(this.listaCargosEnviados.length > 0){
      this.dadosUsuarioService.createOfficeByIdEmpresa(this.idEmpresa, lista)
      .pipe(take(1))
      .subscribe({
        next: (resposta: any) => {
          this.listaCargosEnviados = [];
          this.resposta = resposta;
          this.abrirAlertSucesso();
          this.fecharIncluirCargo();
        },
        error: (error) => {
          console.log(error);
          this.mensagemErro = error.error.mensagem;
          this.abriAlertErro();
        }
      })
    }
    else{
      this.mensagemErro = "Por favor, adicione o cargo e selecione-o.";
      this.abriAlertErro();
    }
  }

  clickExclude(cargo) {

    if (this.listaCargos.includes(cargo)) {
      this.procuraCargo = this.listaCargos.indexOf(cargo);
      this.listaCargos.splice(this.procuraCargo, 1);

      if (this.listaCargosEnviados.includes(cargo)) {
        this.procuraCargo = this.listaCargosEnviados.indexOf(cargo);
        this.listaCargosEnviados.splice(this.procuraCargo, 1);
      }
    }

  }
}
